import SignIn from '@/screens/SignIn';

export default function AuthSignInIndexRoute() {
  return <SignIn />;
}
